const InvoiceableType = Object.freeze({
  PERSON: 'App\\Models\\Person',
  SUPPLIER: 'App\\Models\\Supplier',
  COMPANY: 'App\\Models\\Company',
  CONTACT: 'App\\Models\\Contact'
})

export default InvoiceableType
